import React, { useState, useEffect } from "react";
import Barcode from "react-barcode";
import { useLocation } from "react-router-dom";
import axios from "axios";

export const BarcodeList = () => {
  const [cases, setCases] = useState([]);
  const location = useLocation();

  // ✅ extract query params
  const queryParams = new URLSearchParams(location.search);
  const startDate = queryParams.get("startDate");
  const endDate = queryParams.get("endDate");
  const accountId = queryParams.get("accounts");
  const excludePrinted = queryParams.get("excludePrinted") === "true";

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const response = await axios.get("https://hms.backend.hiragroupcloud.com/api/cases/cases");

        let caseData = response.data;

        // ✅ filter by date range
        if (startDate && endDate) {
          const start = new Date(startDate);
          const end = new Date(endDate);
          caseData = caseData.filter((c) => {
            const caseDate = new Date(c.start_date);
            return caseDate >= start && caseDate <= end;
          });
        }

        // ✅ filter by account
        if (accountId && accountId !== "") {
          caseData = caseData.filter((c) => c.accountId === accountId);
        }

        // ✅ handle excludePrinted
        if (excludePrinted) {
          caseData = caseData.filter((c) => !c.printed);
        }

        setCases(caseData);
      } catch (error) {
        console.error("Error fetching cases:", error);
      }
    };

    fetchCases();
  }, [startDate, endDate, accountId, excludePrinted]);

  // ✅ auto-print
  useEffect(() => {
    const timer = setTimeout(() => {
      window.print();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="wrapper">
      {cases.map((c, index) => (
        <div className="label" key={c._id} style={{ pageBreakBefore: index > 0 ? "always" : "auto" }}>
          <div style={{ fontSize: "22px" }}>{c.provider_name}</div>
          <div style={{ fontSize: "18px" }}>{c.case_id}</div>
          <div className="bold">
            {new Date(c.start_date).toLocaleDateString("en-GB")}
          </div>
          <Barcode
            value={c.case_id}
            width={1.5}
            height={40}
            displayValue={false}
            margin={0}
          />
        </div>
      ))}

      {/* ✅ same styles as PrintWorkTicketSticker */}
      <style>{`
        * {
          box-sizing: border-box;
        }
        html, body, #root, .App, .wrapper {
          margin: 0 !important;
          padding: 0 !important;
          font-family: Arial, sans-serif;
          width: 100%;
          height: 100%;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        }
        .label {
          width: 52.07mm;
          height: 38.1mm;
          border: 1px solid #ccc;
          padding: 1mm;
          font-size: 16px;
          margin: 0 !important;
        }
        .bold {
          font-weight: bold;
          font-size: 1.2em;
        }
        @media print {
          @page {
            size: 52.07mm 38.1mm;
            margin: 0;
          }
          body, html {
            margin: 0 !important;
            padding: 0 !important;
            width: 52.07mm;
            height: 38.1mm;
          }
          .label {
            margin: 0 !important;
            padding: 2mm;
            border: none;
            width: 52.07mm;
            height: 38.1mm;
            position: relative;
            transform: rotate(0deg);
          }
          .wrapper {
            width: 52.07mm;
            height: 38.1mm;
            display: block;
          }
        }
      `}</style>
    </div>
  );
};

export default BarcodeList;
